import React, { useState } from 'react'
import {
  NavWrapper,
  Container,
  NavSection,
  BrandLogo,
  BrandText,
  NavList,
  NavListText,
  NavListItem,
  Button,
  ButtonInner,
  Avatar,
  AvatarInner,
  Language,
  LanguageInner,
  MenuIcon
} from './styled'
import SubNav from './SubNav'
import styled from 'styled-components'
import BtnDropDown from './BtnDropDown'
import { withRouter  } from 'react-router-dom'
import withFluidContainer from '../Common/HOC/withFluidContainer'
import Link, { onClickLink } from '../common3/Link'

import intersection from 'lodash/intersection'



const ButtonWrapper = styled.div`
  position: relative;
`

const Menu = ({ data, setMobileMenuOpen, history, inlineClassName, user }) => {
  const [hovered, setHovered] = useState()
  const [openDropDown, setOpenDropDown] = useState()

  const { theme, content } = data

  const sections = content.map((section, i) => {
    if (section.type === 'logo') {
      return (
        <NavSection key={i} className="section-logo">
          {/* Wrap with router link to home */}
          <Link to={section.url} style={{ textDecoration: 'none', color: 'inherit' }}>
            {section.src ? <BrandLogo className="logo" src={section.src} alt={section.alt} /> : <BrandText className="brand-logo">{section.alt}</BrandText>}
          </Link>
          {/* Wrap end */}
        </NavSection>
      )
    }

    if (section.type === 'nav') {
      return (
        <NavSection key={i} className="section-nav">
          <NavList>
            {section.navItems.map((navItem, i) => {
              const { isAuth, enableAuth } = navItem

              if( enableAuth ) {
                if( isAuth && ! user ) {
                  return null
                }

                if( ! isAuth && user ) {
                  return null
                }
              }

            

              if( navItem.roles ) {
                if( ! user) {
                  return null;
                }

                const { roles = [] } = user;

                if( navItem.roles.length && intersection(navItem.roles, roles ).length === 0 ) {
                  return null
                }

              }
 

              // Wrap with router link to navItem.href
              // navItem.url ? () => history.push('/' + navItem.url) : () => { }
              return (<NavListItem key={i} hoverColor={theme.hoverColor} onMouseEnter={() => setHovered(i)} onClick={onClickLink(navItem.url, history)}>
                <NavListText color={theme.navItemColor}>{navItem.heading}</NavListText>
                {navItem.sub.length
                  ? <SubNav navItem={navItem} theme={theme} hovered={hovered} index={i} />
                  : ''
                }
              </NavListItem >)
            })}
          </NavList >
        </NavSection>
      )
    }

    if (section.type === 'buttons') {
      return (
        <NavSection key={i} className="section-buttons">
          {section.buttons.map((button, i) => (
            button.type === 'button'
              ? (
                <React.Fragment>
                  {button.sub && button.sub.length
                    ? (
                      <ButtonWrapper>
                        <Button key={i} open={openDropDown === i} bgColor={button.bgColor} prio={button.prio} onClick={() => setOpenDropDown(i)}>
                          <ButtonInner color={button.color}>{button.text}</ButtonInner>
                        </Button>
                        <BtnDropDown open={openDropDown === i} setOpen={setOpenDropDown} subItems={button.sub} />
                      </ButtonWrapper>
                    )
                    : (
                      <Button key={i} bgColor={button.bgColor} prio={button.prio} onClick={() => history.push('/' + button.url)}>
                        <ButtonInner color={button.color}>{button.text}</ButtonInner>
                      </Button>
                    )
                  }
                </React.Fragment>
              )
              : button.type === 'avatar'
                ? (
                  <React.Fragment>
                    {button.sub && button.sub.length
                      ? (
                        <ButtonWrapper>
                          <Avatar key={i} open={openDropDown === i} bgColor={button.bgColor} prio={button.prio} onClick={() => setOpenDropDown(i)}>
                            <AvatarInner color={button.color}>{button.text}</AvatarInner>
                          </Avatar>
                          <BtnDropDown open={openDropDown === i} setOpen={setOpenDropDown} subItems={button.sub} />
                        </ButtonWrapper>
                      )
                      : (
                        <Avatar key={i} bgColor={button.bgColor} prio={button.prio} onClick={() => history.push('/' + button.url)}>
                          <AvatarInner color={button.color}>{button.text}</AvatarInner>
                        </Avatar>
                      )
                    }
                  </React.Fragment>
                )
                : (
                  <Language key={i} prio={button.prio} onClick={() => { }} active={button.text === '🇬🇧' ? false : true}>
                    <LanguageInner>{button.text}</LanguageInner>
                  </Language>
                )
          ))}
        </NavSection>
      )
    }

    if (section.type === 'empty') {
      return <NavSection key={i} />
    }

    return ''
  })

  return (
    <NavWrapper className={`sp-navbar sp-navbar-desktop ${inlineClassName ? inlineClassName : ''}`} bgColor={theme.bgColor}>
      <Container className="container">
        {sections}
        <NavSection className="section-menu-icon">
          <MenuIcon className="far fa-bars" onClick={() => setMobileMenuOpen(true)} />
        </NavSection>
      </Container>
    </NavWrapper>
  )
}

export default withRouter(withFluidContainer(Menu))